import translate from '../../../i18n'
import {
  CouponTemplateStatusOptions,
  couponTypeList,
  TestSideOptions,
} from '../../../pages/coupon-templates-container/constant'
import {
  couponTemplateCategoryOptions,
  ICouponTemplateFilterParams,
} from '../../../pages/coupon-templates-container/share-type'
import { LocaleType } from '../../../share-types'
import FormattedMessage from '../../intl/format-message'
import { SearchOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, Input, Select } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'

interface ICouponTemplateFilter {
  locale: LocaleType
  onSearch: (value: ICouponTemplateFilterParams) => void
  formData: ICouponTemplateFilterParams | undefined
}
const { Option } = Select

const CouponTemplateFilter = (props: ICouponTemplateFilter) => {
  const { onSearch, formData } = props
  const [form] = Form.useForm()
  useEffect(() => {
    if (formData) {
      form.setFieldsValue({
        ...formData,
        startDate: formData.startDate ? dayjs(formData.startDate) : undefined,
        endDate: formData.endDate ? dayjs(formData.endDate) : undefined,
      })
    }
  }, [formData])
  const onFinish = (values: ICouponTemplateFilterParams) => {
    onSearch({
      ...values,
      code: values.code ? values.code.trim() : undefined,
      startDate: values.startDate ? dayjs(values.startDate).utc().format() : undefined,
      endDate: values.endDate ? dayjs(values.endDate).utc().format() : undefined,
    })
  }

  return (
    <Form form={form} layout="inline" className="filter-inline-form" onFinish={onFinish}>
      <Form.Item name="name" label={`${translate('couponTemplates.name')}`}>
        <Input placeholder="输入名称" />
      </Form.Item>
      <Form.Item name="discountType" label={translate('couponTemplates.discountType')}>
        <Select style={{ width: 130 }} allowClear>
          {couponTypeList.map(couponType => (
            <Option key={couponType.value} value={couponType.value}>
              {couponType.label}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name="status" label={translate('couponTemplates.status')}>
        <Select style={{ minWidth: 130 }} allowClear>
          {CouponTemplateStatusOptions.map(item => {
            return (
              <Option key={item.value} value={item.value}>
                {item.label}
              </Option>
            )
          })}
        </Select>
      </Form.Item>
      <Form.Item name="code" label={translate('couponTemplates.code')}>
        <Input placeholder="输入优惠码" />
      </Form.Item>
      <Form.Item name="startDate" label={translate('referralCampaigns.startDatetime')}>
        <DatePicker showTime />
      </Form.Item>
      <Form.Item name="endDate" label={translate('referralCampaigns.endDatetime')}>
        <DatePicker showTime />
      </Form.Item>
      <Form.Item name="testSide" label={translate('testSide')}>
        <Select style={{ minWidth: 130 }} allowClear>
          {TestSideOptions.map(item => {
            return (
              <Option key={item.value} value={item.value}>
                {item.label}
              </Option>
            )
          })}
        </Select>
      </Form.Item>
      <Form.Item name="category" label={translate('couponTemplates.category')}>
        <Select style={{ minWidth: 130 }} allowClear>
          {couponTemplateCategoryOptions.map(item => {
            return (
              <Option key={item.value} value={item.value}>
                {item.label}
              </Option>
            )
          })}
        </Select>
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit" type="primary" icon={<SearchOutlined />}>
          <FormattedMessage id="search"></FormattedMessage>
        </Button>
      </Form.Item>
    </Form>
  )
}

export default CouponTemplateFilter
